module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/training-unit-lvl3-50.e9b3d50f.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/training-unit-lvl3-50.png
// module id = 3568
// module chunks = 11